import React from "react";
import { NewsData } from "../../../../lib/types";
import { NEWS_DETAIL } from "../../../../lib/enums";
import NewsPersonRange from "./NewsPersonRange";
import NewsPersonMelee from "./NewsPersonMelee";

interface IProps {
  round: NewsData;
}

const NewsPersonBattleRound = ({
  round
}: IProps) => {
  const fightingBannersA = round.details[NEWS_DETAIL.FightingBanners]?.value.split("|")[0].split(";");
  const fightingBannersB = round.details[NEWS_DETAIL.FightingBanners]?.value.split("|")[1].split(";");
  return (
    <>
      <div>
        <strong className="white">Turn {round.details[NEWS_DETAIL.BattleRound].value}</strong>
      </div>
      <div className="text-item" style={{ fontWeight: "normal", borderTop: "none", marginBottom: 0 }}>
        {round.details[NEWS_DETAIL.IdleBanners]?.value
        && round.details[NEWS_DETAIL.IdleBanners].value.split("|").map((ib: string) => <div>
          <em>{ib}</em> got idle
        </div>)
        }
        {round.details[NEWS_DETAIL.TransferStarted]?.value
        && round.details[NEWS_DETAIL.TransferStarted].value.split("|").map((tb: string) => {
          const details = tb.split(";");
          return <div><em>{details[0]}</em> moves to <em>{details[1]}</em></div>
        })
        }
        {round.details[NEWS_DETAIL.EngagedInBattle]?.value
        && round.details[NEWS_DETAIL.EngagedInBattle].value.split("|").map((ib: string) => <div>
          <em>{ib}</em> got engaged in fight
        </div>)
        }

        {fightingBannersA?.map((fb, index) => <><em>{fb}</em>{index ? ";" : ""}</>)}
        <div><i className="icon icon-armada middle"/></div>
        {fightingBannersB?.map((fb, index) => <><em>{fb}</em>{index ? ";" : ""}</>)}

        {round.details[NEWS_DETAIL.RangePhaseDetail]?.value
        && <NewsPersonRange round={round} />}

        {round.details[NEWS_DETAIL.MeleeTurnsDetails]?.value
        && <NewsPersonMelee round={round} />}

        {round.details[NEWS_DETAIL.DefeatedBanners]?.value
        && round.details[NEWS_DETAIL.DefeatedBanners].value.split("|").map((db: string) => <div>
          <em>{db}</em> is defeated and left the battle
        </div>)
        }
      </div>
    </>)
}

export default NewsPersonBattleRound;
